import { useLayoutEffect, useRef, useState } from 'react';
import { EditableHeading } from '@vibe/core';
import { PAGE_NAME_MAX_LENGTH } from './PageSettingsModal';

type EditablePageNameProps = {
  name: string;
  onChange: (newName: string) => void;
};

export function EditablePageName({ name, onChange }: EditablePageNameProps) {
  const headingRef = useRef<HTMLElement | null>(null);
  const [isEditing, setIsEditing] = useState(false);
  // bumped to remount the heading when a rename is rejected, so it drops the rejected draft
  const [editorKey, setEditorKey] = useState(0);

  // EditableHeading has no maxLength prop, so apply the same limit as the settings modal to its input
  useLayoutEffect(() => {
    if (isEditing) {
      headingRef.current?.querySelector('input')?.setAttribute('maxlength', String(PAGE_NAME_MAX_LENGTH));
    }
  }, [isEditing]);

  function rename(newName: string) {
    const trimmedName = newName.trim();

    if (!trimmedName) {
      setEditorKey((key) => key + 1);
      return;
    }

    if (trimmedName !== name) {
      onChange(trimmedName);
    }
  }

  return (
    <EditableHeading
      key={editorKey}
      ref={headingRef}
      type="h3"
      weight="bold"
      value={name}
      placeholder="Page name"
      aria-label="Page name"
      onChange={rename}
      onEditModeChange={setIsEditing}
      tooltipProps={{ content: 'Click to rename', position: 'bottom' }}
    />
  );
}
